import { Accordion } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { OnBackorderAccordionText, OnBackorderText } from "constants/text";
import OrderDetailsOnBackorderAccordionGrid from "./OrderDetailsOnBackorderAccordionGrid";
import {
	OrderDetailsOnBackorderAccordionDetails,
	StyledAccordionSummary
} from "components/OrderDetailsLineItem/orderDetailsOnBackorderAccordion.styles";
import { FC, useState } from "react";
import { getOrderLineItems } from "pages/OrderPages/utils/OrderDetailUtil.ts";
import { models } from "types/api/viewModels.ts";

interface OrderDetailsOnBackorderAccordionProps {
	orderDetail: models["OrderDetailViewModel"] | null | undefined;
	lineItemsOnBackorderCount: number;
}

export const OrderDetailsOnBackorderAccordion: FC<OrderDetailsOnBackorderAccordionProps> = ({
	orderDetail,
	lineItemsOnBackorderCount
}) => {
	const [accordionIsOpen, setAccordionIsOpen] = useState(true);
	const orderLineItems = getOrderLineItems(orderDetail);

	if (!orderDetail) return null;

	const filteredOrderLineItems = orderLineItems?.filter(
		(item) =>
			(item?.partInfo?.partsQuantityBackordered !== undefined && item.partInfo.partsQuantityBackordered !== 0) ||
			item?.quantityBackordered !== 0
	);

	return (
		<Accordion
			defaultExpanded
			data-testid="on-backorder-accordion"
			key={orderDetail?.orderId}
			onChange={() => setAccordionIsOpen((prev) => !prev)}
		>
			<StyledAccordionSummary
				expandIcon={<ExpandMoreIcon sx={{ color: "var(--orange-500)" }} />}
				aria-controls="panel1a-content"
				id="panel1a-header-backorder"
				data-id={`on-backorder-accordion-${accordionIsOpen ? "open" : "closed"}`}
			>
				<img
					src="/assets/BackorderIcon.svg"
					alt="Order Details Backorder Logo"
					data-testid="backorder-logo"
				/>
				<span>
					{OnBackorderText} ({lineItemsOnBackorderCount})
				</span>
			</StyledAccordionSummary>
			<OrderDetailsOnBackorderAccordionDetails>
				<p>{OnBackorderAccordionText}</p>
				{filteredOrderLineItems?.map((item, index) => (
					<OrderDetailsOnBackorderAccordionGrid
						key={index}
						orderDetail={orderDetail}
						partsQuantityBackordered={item?.partInfo?.partsQuantityBackordered}
						parts={item.partInfo?.parts}
						sku={item?.sku}
						itemDescription={item?.description}
						quantityBackordered={item?.quantityBackordered}
					/>
				))}
			</OrderDetailsOnBackorderAccordionDetails>
		</Accordion>
	);
};

export default OrderDetailsOnBackorderAccordion;
